import http from './http';

export const sendMessageChatVisor = (message) =>
  http.post('/chat-visor/message', message).then((res) => res.data);

export const connect = (action) =>
  http.post('/chat-visor/connect', action).then((res) => res.data);

export const endChatVisor = ({ agent, supervisor, from }) =>
  http
    .post('/chat-visor/end', { agent, supervisor, from })
    .then((res) => res.data);

export const logoff = (action) =>
  http.post('/chat-visor/logoff', action).then((res) => res.data);

export const supervisorsLogged = (agentId) =>
  http
    .get('/chat-visor/supervisors-available', {
      params: {
        agent: agentId,
      },
    })
    .then((res) => res.data);

export const startNewChatVisor = (params) =>
  http.post('/chat-visor/new', params).then((res) => res.data);
